
/**
 * button_change_number_pressed
 * нажали на изменить на экране подтверждения
 */
export interface ButtonChangeNumberPressed {}

export function mapButtonChangeNumberPressedEvent(event: ButtonChangeNumberPressed): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'button_change_number_pressed',
    event_properties: {},
  };
}
